import Marquee from "react-fast-marquee";

export const Ribbon = () => {
  const items = ["EL REY DEL SABOR", "AUTHENTIC LATIN STREET FOOD", "★ 5.0", "TACOS · BURRITOS · PUPUSAS", "BIRRIA", "STAMFORD · CT", "HECHO A MANO"];
  return (
    <div className="py-6 border-y border-white/10 bg-[#0A0A0A] relative z-10">
      <Marquee speed={45} gradient={false} autoFill>
        {items.map((it, i) => (
          <span key={i} className="font-display uppercase text-4xl md:text-6xl mx-8 stroke-text flex items-center gap-8">
            {it}
            <span className="text-[#FF5A00] not-italic">•</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
